import React from 'react';


const CurrentUserTop = ({ user }) => {
    if (!user) {
        return <div>Loading...</div>;
    }

    const { userName, tenant } = user;

    return (
        <span className='text-warning mt-2 pr-5'>
            {userName} / <span className='text-secondary small'>{tenant}</span>
        </span>
    );
};

export default CurrentUserTop;